module.exports = __webpack_public_path__ + "static/media/reconcileOrder.67fc6a98.svg";